import React, { Component } from 'react';
import { BaseURLDev, headers } from '../../../../../_utils/config';
import { toDMYDate } from '../../../../../_utils/convert_datetime';
import { toIDR } from '../../../../../_utils/tocurrency';
import { 
   Menu, Icon, Label, Form, Select, Button, Loader, Message, Pagination
} from 'semantic-ui-react';
import _ from 'lodash';
import { DateRangePicker, isInclusivelyBeforeDay } from 'react-dates';
import swal from 'sweetalert'
import printJS from 'print-js';
import moment from 'moment'
import { fetchOPD } from '../../../../../_utils/localstorage';

export default class BPLaporan extends Component {
    constructor(props){
        super(props);
        this.state = {
            data: [],
            requests:false,
            
            startDate: null,
            endDate: null,
            status_val: null,

            total:[],
            status:[],
            jumlah:0,
            semua:true,
            semua_data:[],
            
            opds:[],
            opd_kode:null,
            opd_name:null,

            activePage:1,
            totalPages:0,
            pageActive: 1,
        }
        this.onFilter = this.onFilter.bind(this);    
        this.onChangeStatus = this.onChangeStatus.bind(this);
        this.onRefresh = this.onRefresh.bind(this);
        this.onChangeOPD = this.onChangeOPD.bind(this);  
    }

    handlePaginationChange = (e, { activePage }) => {
        if (this.state.pageActive === activePage){
            return false;
        }

        this.setState({ activePage, pageActive: activePage, requests: true })
        fetch(`${BaseURLDev}/bp?report=true&page=${activePage}&status=1`,{headers})
        .then(response => {
            if (!response.ok) { 
                  return Promise.reject(response.statusText);
              }
            return response.json();
        })
        .then(resJSON => {
            var tam1=[]; var status=[]; var jum=0; var semua_data=[];
            var jumBelumSTS=0; var jumSudahSTS=0; var jumVer=0;
            for(var i=0;i<resJSON.data.length;i++){
                var tam2=0; var stat="";
                for(var j=0; j<resJSON.data[i].rincian.length;j++){
                    tam2=tam2+resJSON.data[i].rincian[j].nilai;
                }
                if(resJSON.data[i].is_active===true && resJSON.data[i].is_verified===false){
                    stat="BP Non STS";
                    jumBelumSTS=jumBelumSTS+1;
                } else if(resJSON.data[i].is_active===false && resJSON.data[i].is_verified===false){
                    stat="BP STS";
                    jumSudahSTS=jumSudahSTS+1;
                } else if(resJSON.data[i].is_active===false && resJSON.data[i].is_verified===true){
                    stat="BP Terealisasi";
                    jumVer=jumVer+1;
                }
                tam1[i]=tam2;
                jum=jum+tam2;
                status[i]=stat;
            }
            semua_data[0]=jumBelumSTS;
            semua_data[1]=jumSudahSTS;
            semua_data[2]=jumVer;
            this.setState({
                data:resJSON.data,
                status:status,
                total:tam1,
                jumlah:jum,
                semua_data:semua_data,
                requests:false,
                totalPages:4,
            })
        });
    }

    opdSelect(){
        if(fetchOPD().length!==0){
           const opds = []
        //    opds.push({'value':0,'text':"Semua Data",'key':10000})         
           for(let i=0; i<fetchOPD().length; i++) {
              opds.push({
                 'value': i,
                 'text': `[${fetchOPD()[i].kode_opd}] ${fetchOPD()[i].opd}`,
                 'key': fetchOPD()[i].kode_opd,     
              })
           }
           this.setState({opds:opds})
        }
    }


    onChangeOPD(e, el){

    }

    onRefresh(){
        this.setState({
            startDate:null,
            endDate:null,
            requests:true
        })

        fetch(`${BaseURLDev}/bp?report=true`,{headers})
        .then(response => {
            if (!response.ok) { 
                swal('Load data gagal',  { icon:'error' })
                this.setState({requests:false});
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
        .then(resJSON => {
            var tam1=[]; var status=[]; var jum=0; var semua_data=[];
            var jumBelumSTS=0; var jumSudahSTS=0; var jumVer=0;
            for(var i=0;i<resJSON.data.length;i++){
                var tam2=0; var stat="";
                for(var j=0; j<resJSON.data[i].rincian.length;j++){
                    tam2=tam2+resJSON.data[i].rincian[j].nilai;
                }
                if(resJSON.data[i].is_active===true && resJSON.data[i].is_verified===false){
                    stat="BP Non STS";
                    jumBelumSTS=jumBelumSTS+1;
                } else if(resJSON.data[i].is_active===false && resJSON.data[i].is_verified===false){
                    stat="BP STS";
                    jumSudahSTS=jumSudahSTS+1;
                } else if(resJSON.data[i].is_active===false && resJSON.data[i].is_verified===true){
                    stat="BP Terealisasi";
                    jumVer=jumVer+1;
                }
                tam1[i]=tam2;
                jum=jum+tam2;
                status[i]=stat;
            }
            semua_data[0]=jumBelumSTS;
            semua_data[1]=jumSudahSTS;
            semua_data[2]=jumVer;
            this.setState({
                data:resJSON.data,
                status:status,
                total:tam1,
                jumlah:jum,
                totalPages:4,
                semua_data:semua_data,
                requests:false
            })
        })
        .catch(err =>{
            swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
                icon: "error",
            }); 
        });
    }

    onFilter(){
        const { startDate, endDate, status_val, kode_opd } = this.state;
        const start_date = startDate===null ? null : startDate.format('YYYY-MM-DD');
        const end_date = endDate===null ? null : endDate.format('YYYY-MM-DD');
        if(startDate===null || endDate===null){
            swal('Pilih range tanggal dulu!',  { icon:'error' });
            this.setState({data: []});
            return false;
        }


        this.setState({requests:true});
        fetch(`${BaseURLDev}/bp?report=true&status_val=${status_val}&start=${start_date}&end=${end_date}&opd=${kode_opd.key}`,{headers})
        .then(response => {
            if (!response.ok) {
                swal('Load data gagal',  { icon:'error' })
                this.setState({requests:false});
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
        .then(resJSON => {
            var tam1=[]; var status=[]; var jum=0; var semua_data=[];
            var jumBelumSTS=0; var jumSudahSTS=0; var jumVer=0;
            for(var i=0;i<resJSON.data.length;i++){
                var tam2=0; var stat="";
                for(var j=0; j<resJSON.data[i].rincian.length;j++){
                    tam2=tam2+resJSON.data[i].rincian[j].nilai;
                }
                if(resJSON.data[i].is_active===true && resJSON.data[i].is_verified===false){
                    stat="Non STS";
                    jumBelumSTS=jumBelumSTS+1;
                } else if(resJSON.data[i].is_active===false && resJSON.data[i].is_verified===false){
                    stat="STS";
                    jumSudahSTS=jumSudahSTS+1;
                } else if(resJSON.data[i].is_active===false && resJSON.data[i].is_verified===true){
                    stat="Terealisasi";
                    jumVer=jumVer+1;
                }
                tam1[i]=tam2;
                jum=jum+tam2;
                status[i]=stat;
            }
            semua_data[0]=jumBelumSTS;
            semua_data[1]=jumSudahSTS;
            semua_data[2]=jumVer;
            this.setState({
                data:resJSON.data,
                status:status,
                total:tam1,
                jumlah:jum,
                totalPages:4,
                semua_data:semua_data,
                requests:false
            })
        })
        .catch(err =>{
            swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
                icon: "error",
            });
        });
    }

    onLoadBP(){
        fetch(`${BaseURLDev}/bp?report=true`,{headers})
        .then(response => {
            if (!response.ok) { 
                swal('Load data gagal',  { icon:'error' })
                this.setState({requests:false});
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
        .then(resJSON => {
            var tam1=[]; var status=[]; var jum=0; var semua_data=[];
            var jumBelumSTS=0; var jumSudahSTS=0; var jumVer=0;
            for(var i=0;i<resJSON.data.length;i++){
                var tam2=0; var stat="";
                for(var j=0; j<resJSON.data[i].rincian.length;j++){
                    tam2=tam2+resJSON.data[i].rincian[j].nilai;
                }
                if(resJSON.data[i].is_active===true && resJSON.data[i].is_verified===false){
                    stat="Non STS";
                    jumBelumSTS=jumBelumSTS+1;
                } else if(resJSON.data[i].is_active===false && resJSON.data[i].is_verified===false){
                    stat="STS";
                    jumSudahSTS=jumSudahSTS+1;
                } else if(resJSON.data[i].is_active===false && resJSON.data[i].is_verified===true){
                    stat="Terealisasi";
                    jumVer=jumVer+1;
                }
                tam1[i]=tam2;
                jum=jum+tam2;
                status[i]=stat;
            }
            semua_data[0]=jumBelumSTS;
            semua_data[1]=jumSudahSTS;
            semua_data[2]=jumVer;
            this.setState({
                data:resJSON.data,
                status:status,
                total:tam1,
                jumlah:jum,
                totalPages:4,
                semua_data:semua_data,
                requests:false
            })
        })
        .catch(err =>{
            swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
                icon: "error",
            }); 
        });
    }
    componentWillMount(){
        // this.onLoadBP();
        this.opdSelect();
    }

    onChangeStatus(e,el){
        this.setState({data: []})
        if(el.value==="10000"){
            this.setState({semua:true})
        } else { 
            this.setState({semua:false})
        }
        this.setState({
            status_val:el.value
        })
    }

    exportData(){
        printJS({
            printable: 'print_data',
            type: 'html',
            modalMessage:"Sedang memuat data...",
            showModal:true,
            maxWidth:'1300',
            font_size:'8pt',
            documentTitle:'Rincian BP',
            targetStyle: [
                'margin',
                'color',
                'border-collapse',
                'border-spacing',
                'border-style',
                'border-style',
                'margin-bottom',
                'padding',
                'Label',
                'background'
            ]
        })
     }
    
    render() {
        const styletb = {
            borderCollapse:'collapse',
            borderSpacing:0,
            borderStyle:'solid',
            width:'100%',
            fontSize:'12px',
            padding:'40px'
        }
        const { data, total, status , semua_data, activePage , totalPages} = this.state;
        const status_bp = [
            {'key':1,'text':'BP (Non STS)','value':"1"},
            {'key':2,'text':'BP (STS)','value':"2"},
            {'key':3,'text':'BP (Terealisasi)','value':"3"},
         ]
        return (
            <div>
                <div>   
                <Message
                    error
                    header='** Penting!'
                    content='Silahkan memilih OPD, Status, serta Rentang Tanggal terlebih dahulu sebelum menekan tombol Filter'
                />                  
                <Menu>
                    <Menu.Item>
                        <Form.Field 
                            control={Select} 
                            search 
                            onChange={(e,el)=>this.setState({kode_opd:el.options[el.value]})} 
                            options={this.state.opds} 
                            name="pilihopd" 
                            placeholder='--Pilih OPD--'
                            ttile='Pilih OPD'
                            style={{width:'250px'}}
                        />
                    </Menu.Item>
                    <Menu.Item>
                        <Form>
                            <Form.Field
                                style={{marginBottom:'6px'}}
                                control={Select} 
                                search          
                                options={status_bp}
                                onChange={this.onChangeStatus} 
                                placeholder='Pilih Status'
                                ttile='Pilih Status'
                            />
                        </Form>
                    </Menu.Item> 
                    <Menu.Item>
                        <DateRangePicker
                            hideKeyboardShortcutsPanel
                            reopenPickerOnClearDates
                            showClearDates
                            minimumNights={0}
                            withPortal
                            showDefaultInputIcon
                            displayFormat="DD/MM/YYYY"
                            small={true}                              
                            numberOfMonths={2}
                            startDatePlaceholderText="Awal"
                            endDatePlaceholderText="Akhir"
                            startDateId="startDateId"
                            endDateId="endDateId"
                            isOutsideRange={day => !isInclusivelyBeforeDay(day, moment())}
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })}
                            focusedInput={this.state.focusedInput}
                            onFocusChange={(focusedInput) => this.setState({ focusedInput })}
                        />
                    </Menu.Item>       
                    <Menu.Item>                     
                        <Button.Group size='small'>
                        <Button content="Filter" disabled={this.state.startDate===null && this.state.endDate===null} color='green' icon='filter' onClick={this.onFilter}/>
                        </Button.Group>
                    </Menu.Item>
                    <Menu.Item position="right">
                        <Button color='blue' size="small" onClick={()=>this.exportData()}> 
                            <p><Icon name='print' className='left floated' />Preview</p>
                        </Button>
                    </Menu.Item>
                </Menu>
                <div ref={el => (this.componentRef = el)} id="print_data">
                <style type="text/css">
                    {"@media print{@page {size: 8.5in 14in; margin: 40px; }}"}
                </style>
                <br/>
                  <div>
                  {
                      (this.state.semua===false)? null :
                      <table>
                          <tbody>
                              <tr>
                                  <td>Jumlah Belum STS</td> 
                                  <td>:</td> 
                                  <td>{semua_data[0]}</td>
                              </tr>
                              <tr>
                                  <td>Jumlah Sudah STS</td> 
                                  <td>:</td> 
                                  <td>{semua_data[1]}</td>
                              </tr>
                              <tr>
                                  <td>Jumlah Terealisasi</td> 
                                  <td>:</td> 
                                  <td>{semua_data[2]}</td>
                              </tr>
                          </tbody>
                      </table>
                  }
                  <br/>
                  {/* <Segment> */}
                  {(this.state.requests || this.state.loading_edit || this.state.loading_detail) ?
                      <Loader active inline='centered' size='medium'>Loading...</Loader>
                  : <div>
                    <table border="1" align="center" style={styletb} width="100%">
                        <tbody>            
                            <tr align="left" style={{background:'#e5e5e5',padding:'4px'}}>
                                <th rowSpan="2" width="4%" style={{padding:'4px',textAlign:"center"}}>No.</th>
                                <th rowSpan="2" width="6%"style={{padding:'4px',textAlign:"center"}}>Status</th>
                                <th colSpan="2" width="20%" style={{padding:'4px',textAlign:"center"}}>Nomor</th>
                                <th colSpan="2" style={{padding:'4px',textAlign:"center"}}>Tanggal</th>
                                {/* <th rowSpan="2" style={{padding:'4px',textAlign:"center"}}>Keterangan</th> */}
                                <th rowSpan="2" style={{padding:'4px',textAlign:"center"}}>Rincian</th>
                                <th rowSpan="2" style={{padding:'4px',textAlign:"center"}}>Total</th>
                            </tr>
                            <tr align="left" style={{background:'#e5e5e5',padding:'4px'}}>
                                <th style={{padding:'4px',textAlign:"center"}}>BP</th>
                                <th style={{padding:'4px',textAlign:"center"}}>STS</th>
                                <th style={{padding:'4px',textAlign:"center"}}>Pembuatan</th>
                                <th style={{padding:'4px',textAlign:"center"}}>Realisasi</th>
                            </tr>
                            {data.length === 0 && 
                                <tr>
                                    <th colSpan="9">Data tidak ditemukan</th>                           
                                </tr>
                            }
                            {_.map(data, (item,i) => (
                              <tr key={i}> 
                                  <td style={{padding:'4px',textAlign:"center"}}>{i+1+(activePage-1)*10}.</td>   
                                  <td style={{padding:'4px',textAlign:"center"}}>
                                  {
                                      (status[i]==="Non STS")?
                                      <Label color='red' horizontal>BP Non STS</Label> :
                                      (status[i]==="STS")?
                                      <Label color='yellow' horizontal>BP STS</Label> :
                                      (status[i]==="Terealisasi")?
                                      <Label color='blue' horizontal>BP Terealisasi</Label> : null
                                  }
                                  </td>                                                
                                  <td style={{padding:'4px',textAlign:"center"}}>{item.no_bukti}</td>
                                  <td style={{padding:'4px',textAlign:"center"}}>{item.no_sts}</td>
                                  <td style={{padding:'4px',textAlign:"center"}}>{toDMYDate(item.created_at)}</td>
                                  <td style={{padding:'4px',textAlign:"center"}}>{toDMYDate(item.tgl_realisasi)}</td>
                                  {/* <td style={{padding:'4px'}}>{item.uraian}</td> */}
                                  <td style={{padding:'4px'}}>
                                  {   
                                      item.rincian.map((isi, j) =>(
                                          <p key={j}>{isi.kd_rek_1+"."+isi.kd_rek_2+"."+isi.kd_rek_3+"."+isi.kd_rek_4+"."+isi.kd_rek_5+"."+isi.kd_rek_6+" = "+isi.uraian_rinc+" : "+toIDR(isi.nilai)}<br/></p>
                                      ))
                                  }
                                  </td>
                                  <td style={{padding:'4px',textAlign:"right"}}>{toIDR(total[i])}</td>
                              </tr>
                              ))}
                        </tbody>   
                    </table>
                    <br/>
                    <table border="1" align="center" style={styletb} width="100%">
                        <tr style={{background:'#e5e5e5'}}>
                            <th style={{padding:'4px', width:'80%'}} align="right">Jumlah</th>
                            <th style={{padding:'4px'}} align="right">
                                {toIDR(this.state.jumlah)}
                            </th>
                        </tr>
                    </table>
                    </div>
                    }
                  </div>
                  </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_report_admin/RegisterBP.js